<div
    class="btn-group p-2 p-lg-0"
    dropdown
    #dropdown="bs-dropdown"
    [dropup]="isDropup"
    [isDisabled]="stepEntries.length === 0"
>
    <ng-container *ngIf="model?.actions?.selectedEntry as selectedEntry">
        <button
            type="button"
            *ngIf="selectedEntry.value !== NOTIFICATION_STATUS_CODE.REMT"
            (click)="onStepButtonClick(selectedEntry)"
            class="btn btn-primary btn-lg split-button px-0 me-auto"
            [disabled]="disableButton(selectedEntry.model) || runAnimation"
        >
            <ng-container *ngIf="runAnimation">
                <fa-icon [icon]="faLoading" [spin]="true"></fa-icon>
            </ng-container>
            <ng-container *ngIf="!runAnimation">
                {{ selectedEntry.displayName }}
            </ng-container>
        </button>
    </ng-container>

    <ng-container *ngIf="model?.actions?.selectedEntry as selectedEntry">
        <button
            *ngIf="selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT"
            class="btn btn-primary btn-lg split-button px-0 me-auto d-lg-none d-block"
            type="button"
            [disabled]="disableButton(selectedEntry.model) || runAnimation"
            (click)="dropdown.toggle(true)"
        >
            {{ selectedEntry.displayName }}
        </button>
    </ng-container>

    <ng-container
        *ngIf="isDropup && stepEntries.length && model.actions.selectedEntry.value !== NOTIFICATION_STATUS_CODE.REMT"
    >
        <button
            class="more-toggler d-lg-none btn btn-secondary btn-lg ms-2"
            type="button"
            dropdownToggle
            [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
            [disabled]="runAnimation"
        >
            <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
    </ng-container>
    <ng-container
        *ngIf="isDropup && stepEntries.length && model.actions.selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT"
    >
        <button
            dropdown
            *ngIf="isDropup && stepEntries.length"
            class="more-toggler d-lg-none btn btn-secondary btn-lg ms-2"
            type="button"
            dropdownToggle
            (click)="dropdown.toggle(true)"
            [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
            [disabled]="runAnimation"
        >
            <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
    </ng-container>

    <button
        *ngIf="!isDropup && stepEntries.length"
        type="button"
        id="button-split"
        class="btn btn-primary btn-lg dropdown-toggle dropdown-toggle-split d-lg-block d-none"
        dropdownToggle
        [attr.aria-label]="'NOTIFICATION_STATUS_STEP_BUTTON_MENU_ARIA_LABEL' | translate"
        [disabled]="runAnimation"
    >
        <ng-container *ngIf="model.actions.selectedEntry.value === NOTIFICATION_STATUS_CODE.REMT">
            <span class="pe-3"> {{ model.actions.selectedEntry.displayName }} </span>
            <span class="caret"></span>
            <span class="sr-only">Toggle Dropdown</span>
        </ng-container>
    </button>

    <ng-container>
        <ul
            class="dropdown-menu dropdown-menu-right"
            *dropdownMenu
            id="dropdown-split"
            role="menu"
            aria-labelledby="button-split"
        >
            <li [ngClass]="dimNonPriorityStatus()" *ngFor="let entry of stepEntries" role="menuitem">
                <button
                    (click)="onStepButtonClick(entry)"
                    class="btn btn-secondary btn-lg"
                    [disabled]="disableButton(entry.model)"
                >
                    <fa-icon
                        class="float-start"
                        *ngIf="
                            entry.value === NOTIFICATION_STATUS_CODE.ROSR ||
                            entry.value === NOTIFICATION_STATUS_CODE.FCC
                        "
                        [icon]="faPhone"
                        size="sm"
                    >
                    </fa-icon>
                    {{ entry.displayName }}
                </button>
            </li>
        </ul>
    </ng-container>
</div>
